"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Link.css");
var react_router_hash_link_1 = require("react-router-hash-link");
var keyboard_1 = require("../../utils/dom/keyboard");
var LinkComp = function (_a, ref) {
    var disabled = _a.disabled, className = _a.className, onClick = _a.onClick, props = __rest(_a, ["disabled", "className", "onClick"]);
    return (React.createElement(react_router_hash_link_1.HashLink, __assign({ "aria-disabled": disabled || undefined }, props, { ref: ref, className: classnames_1.default('Link', className, {
            'Link-disabled': disabled,
        }), onKeyDown: function (e) {
            if (disabled && keyboard_1.isKeyReturn(e))
                e.preventDefault();
        }, onClick: function (e) {
            if (disabled)
                e.preventDefault();
            else if (onClick)
                onClick(e);
        } })));
};
exports.LinkFR = React.forwardRef(LinkComp);
exports.Link = React.memo(exports.LinkFR);
